




import { Component, Vue } from "vue-property-decorator";
import { applyOpenCourse } from "@/api/seller";
import { getQueryString, Base64 } from "@/libs/tools";

@Component
export default class FwhLoginOpenCourse extends Vue {
    mounted(): void {
        this.applyCourse();
    }
    applyCourse() {
        let adPlanId = Number(getQueryString("adPlanId"));
        let productId = Number(getQueryString("productId"));
        let serviceStaffId = Number(getQueryString("serviceStaffId"));
        let source = getQueryString("source") ? getQueryString("source") : "";
        let nickname = "";
        if (localStorage.getItem("user")) {
            nickname = JSON.parse(localStorage.getItem("user")).nickname;
            nickname = Base64.decode(nickname);
        }
        applyOpenCourse(
            adPlanId,
            productId,
            serviceStaffId,
            nickname,
            source
        ).then(res => {
            // @ts-ignore
            if (res.code === 200) {
                serviceStaffId = res.data.serviceStaffId;
                location.replace(
                    location.origin +
                        "/openCourseSeller?serviceStaffId=" +
                        serviceStaffId
                );
            }
        });
    }
}
